import * as F from 'reduker/fp-utils'
import entities from 'reduker/entities'
import request from 'reduker/request'

export const getSearches = state => state.searches.searches

const getSearchesRequest = state => state.searches.searchesRequest

export const getIsSearchesFetching = F.pipe(
  getSearchesRequest,
  request.getIsRequesting,
)

export const getSearchDetailsFilters = state =>
  state.searches.searchDetailsFilters

export const getSearchDetailsResults = F.pipe(
  state => state.searches.searchDetailsResults,
  entities.getAsList,
)

const getSearchDetailsRequest = state => state.searches.searchDetailsRequest

export const getIsSearchDetailsFetching = F.pipe(
  getSearchDetailsRequest,
  request.getIsRequesting,
)

export const getSearchDetailsError = F.pipe(
  getSearchDetailsRequest,
  request.getError,
)

export const getSearchOptions = state => state.searches.searchOptions

export const getSearchToSave = state => state.searches.searchToSave
